// import utils from '@/services/utils';
import excel from '@/services/excel';

export default {
  DCPX(englishCourseData) {
    const { quizzes } = englishCourseData;
    const testArray = quizzes.map((item, index) => [null, `${index + 1}.${item.explain}`]);
    const answerArrat = quizzes.map((item, index) => [null, `${index + 1}.${item.text}`]);
    const results = [testArray, answerArrat];
    for (let j = 0; j < testArray.length; j += 1) {
      const element = testArray[j];
      if (element[1].length > 40) {
        const str = element[1].substr(40, element[1].length - 40);
        const newElement = [null, `   ${str} __________`];
        element[1] = element[1].substr(0, 40);
        testArray.splice(j + 1, 0, newElement);
      } else if (!/__________/.test(element[1])) {
        element[1] = `${element[1]} __________`;
      }
    }
    for (let i = 0; i < results.length; i += 1) {
      results[i].unshift([null, '默写']);
      results[i].unshift([null, englishCourseData.navigation]);
    }
    const options = {
      cols: [{ wpx: 40 }, { wch: 35 }],
      rows: testArray.map(() => ({ hpx: 30 })),
    };
    excel.openDownloadDialog(results, ['测试卷', '答案'], `${englishCourseData.navigation}.xlsx`, options);
  },
  CHXZ(englishCourseData) {
    const { quizzes } = englishCourseData;
    const testArray = [];
    const numbers = ['A', 'B', 'C', 'D'];
    quizzes.forEach((item, index) => {
      testArray.push([null, `${index + 1}.${item.mode === 1 ? item.text : item.explain}`]);
      if (item.options.length) {
        for (let j = 0; j < item.options.length; j += 1) {
          const option = item.options[j];
          testArray.push([null, `${numbers[j]}.   ${option}`]);
        }
      }
    });
    const answerArrat = quizzes.map((item, index) => [null, `${index + 1}.   ${item.mode === 1 ? item.explain : item.text}`]);
    const results = [testArray, answerArrat];
    for (let i = 0; i < results.length; i += 1) {
      results[i].unshift([null, `${quizzes[0].mode === 1 ? '英译汉' : '汉译英'}`]);
      results[i].unshift([null, englishCourseData.navigation]);
    }
    const options = {
      cols: [{ wpx: 40 }, { wch: 35 }],
      rows: testArray.map(() => ({ hpx: 30 })),
    };
    excel.openDownloadDialog(results, ['测试卷', '答案'], `${englishCourseData.navigation}.xlsx`, options);
  },
  exportExcel(englishCourseData) {
    if (englishCourseData.quizzes[0].code === 'DCPX') {
      this.DCPX(englishCourseData);
    } else {
      this.CHXZ(englishCourseData);
    }
  },
};
